import { useNavigate } from "react-router-dom";
import FaqSect from "./faqSect";
import Footer from "./Footer";
import { MdEmail, MdHelpOutline, MdPhone } from "react-icons/md";
import { faqsForCustomers } from "../constants/homePageConstant";

export default function Support() {
  const navigate = useNavigate();

  return (
    <div className="font-poppins h-[calc(100vh-80px)] mt-[80px] overflow-y-auto scrollbar-hide">
      {/* Hero strip - same gradient as home */}
      <div
        className="w-full py-12 md:py-16 flex justify-center items-center"
        style={{
          background:
            "linear-gradient(90deg, #02537F 0%, #0585CB 60%, #035885 100%)",
        }}
      >
        <div className="mx-4 md:mx-6 lg:mx-14 text-center max-w-3xl">
          <h1 className="text-white font-bold text-3xl md:text-4xl lg:text-5xl leading-tight mb-3">
            Help & Support
          </h1>
          <p className="text-white/90 text-base md:text-lg">
            Get answers, reach our team, or learn how to get the most out of
            Tydii.
          </p>
        </div>
      </div>

      {/* Contact cards */}
      <div className="mx-4 md:mx-6 lg:mx-14 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          <a
            href="mailto:support@tydii.io"
            className="flex items-start gap-4 p-6 rounded-2xl bg-white border border-gray-200 shadow-sm hover:shadow-md hover:border-[#1D6076]/30 transition-all"
          >
            <div className="h-12 w-12 rounded-full bg-[#E8F9FF] flex items-center justify-center shrink-0 text-[#02537F]">
              <MdEmail className="w-6 h-6" />
            </div>
            <div>
              <h3 className="font-semibold text-[#1E1F21] mb-1">Email support</h3>
              <p className="text-sm text-[#50555C] mb-2">
                We typically respond within 24 hours.
              </p>
              <span className="text-[#02537F] font-medium text-sm">
                help@tydii.io
              </span>
            </div>
          </a>
          <a
            href="mailto:help@tydii.io"
            className="flex items-start gap-4 p-6 rounded-2xl bg-white border border-gray-200 shadow-sm hover:shadow-md hover:border-[#1D6076]/30 transition-all"
          >
            <div className="h-12 w-12 rounded-full bg-[#E8F9FF] flex items-center justify-center shrink-0 text-[#02537F]">
              <MdHelpOutline className="w-6 h-6" />
            </div>
            <div>
              <h3 className="font-semibold text-[#1E1F21] mb-1">Order & account help</h3>
              <p className="text-sm text-[#50555C] mb-2">
                Questions about an order or your account?
              </p>
              <span className="text-[#02537F] font-medium text-sm">
                help@tydii.io
              </span>
            </div>
          </a>
          <div className="flex items-start gap-4 p-6 rounded-2xl bg-[#F6FCFF] border border-[#1D6076]/20">
            <div className="h-12 w-12 rounded-full bg-[#E8F9FF] flex items-center justify-center shrink-0 text-[#02537F]">
              <MdPhone className="w-6 h-6" />
            </div>
            <div>
              <h3 className="font-semibold text-[#1E1F21] mb-1">In-app support</h3>
              <p className="text-sm text-[#50555C]">
                Use the Help or Support section inside the Tydii app for quick
                answers and to submit a request.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-10 flex justify-center">
          <button
            type="button"
            onClick={() => navigate("/")}
            className="inline-flex items-center justify-center rounded-lg text-white bg-[#02537F] hover:bg-sky-800 px-6 py-2.5 text-base font-bold shadow-sm transition"
          >
            Back to Home
          </button>
        </div>
      </div>

      {/* FAQ - reuse existing component */}
      <div className="bg-gradient-to-b from-[#F3FBFF] to-[#EEF9FF]">
        <div className="mx-4 md:mx-6 lg:mx-14 py-6 md:py-12">
          <FaqSect faq={faqsForCustomers}/>
        </div>
      </div>

      <div className="bg-[#034F78]">
        <Footer />
      </div>
    </div>
  );
}
